'use client'

import { GoogleTagManager } from '@next/third-parties/google'
import { useEffect, useState } from 'react'
import {
    MARKETING_PURPOSE,
    MEASUREMENT_PURPOSE,
    usePurposeConsent,
} from '@/features/gdpr/use-purpose-consent'

// GTM loads once the user consents to Measurement (iubenda purpose 4) or Marketing (purpose 5) —
// the container holds tags of both kinds. Until then no Google script is fetched and nothing in
// the container fires. The iubenda banner callback pushes its consent events onto window.dataLayer
// (see cookie-banner.tsx); GTM flushes that queue on load.
const GTM_ID = 'GTM-PFQNDKF'

export const GoogleTagManagerConsentGate = () => {
    const measurementConsent = usePurposeConsent(MEASUREMENT_PURPOSE)
    const marketingConsent = usePurposeConsent(MARKETING_PURPOSE)
    const [isLoaded, setIsLoaded] = useState(false)

    // Latch once granted: withdrawing consent can't unload an already-fetched script, so we keep
    // GTM mounted rather than flip-flopping. A withdrawal takes effect on the next page load.
    useEffect(() => {
        if (measurementConsent === true || marketingConsent === true) setIsLoaded(true)
    }, [measurementConsent, marketingConsent])

    if (!isLoaded) return null

    return <GoogleTagManager gtmId={GTM_ID} />
}
